import { useEffect, useReducer, useRef, useState } from "react";
import { removeDomainFromUrl, getTimeFromSeconds, transformDrillUrl, getLessonUrl, isDrillsPath, toggleAutoplay } from "../../helpers/utils";
import { axiosRequest, axiosRequestData } from "../../helpers/axios";
import parse from "html-react-parser";
import { Box, Grid, Switch, useMediaQuery, useTheme } from "@mui/material";
import { Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import StarBorderRoundedIcon from "@mui/icons-material/StarBorderRounded";
import StarRateRoundedIcon from "@mui/icons-material/StarRateRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RecordResultsDialog from "../dialogs/recordResultsDialog";
import ResultsDialog from "../dialogs/resultsDialog";
import React from "react";
import { Course } from "../../interfaces/course";
import { Lesson } from "../../interfaces/lesson";
import styles from "./playlist.module.css";
import { useLocation, useNavigate } from "react-router";
import { CurrentLesson } from "../../interfaces/currentLesson";
import { Accelerator } from "../../interfaces/accelerator";
import {
   Accordion,
   AccordionDetails,
   AccordionSummary,
   BorderLinearProgressHeight6,
} from "./accoridonStyles";
import { Link } from "../../interfaces/link";
import {
   lessonCompleteEvent,
   favoriteVideoEvent,
   drillCompleteEvent,
} from "../mixPanelEvents/mixPanelEvents";
import { addToNavigationFavoriteCount } from "../../helpers/document";
import { useAccelerator } from "../../hooks/acceleratorDataProvider";
import DidYouKnowBannerCoach from "../banner/didYouKnowBannerCoach/didYouKnowBannerCoach";
import DidYouKnowMessageBanner from "../banner/didYouKnowMessage/didYouKnowMessageBanner";
import MotivationMessages from "../headers/motivationMessages/motivationMessages";
import CheckAnimation from "../icons/animatedCheck";
import AutoplayPopover from "../dialogs/autoplayPopover";

const BALL_STRIKING_ID = 113256;
const FIRST_COURSE_ID = 25298;
const SECOND_COURSE_ID = 25309;
const THIRD_COURSE_ID = 25323;
const FOURTH_COURSE_ID = 25344;
const FIFTH_COURSE_ID = 25355;

// const BALL_STRIKING_ID = 85298;drill
// const FIRST_COURSE_ID = 25344;
// const SECOND_COURSE_ID = 25355;
// const THIRD_COURSE_ID = 2573;
// const FOURTH_COURSE_ID = 2575;
// const FIFTH_COURSE_ID = 2576;

function reducer(
   lessonPlaylist: Lesson[],
   action: { type: string; lessonID: number; lessons: Lesson[] }
) {
   switch (action.type) {
      case "set": {
         return action.lessons;
      }
      case "toggle_favorite": {
         return lessonPlaylist.map((t) => {
            if (t.ID === action.lessonID) {
               return { ...t, is_fav: !t.is_fav };
            } else {
               return t;
            }
         });
      }
      case "complete_lesson": {
         return lessonPlaylist.map((t) => {
            if (t.ID === action.lessonID) {
               return { ...t, complete: true };
            } else {
               return t;
            }
         });
      }
      default: {
         Error("Unknown action: " + action.type);
      }
   }
   throw Error("Unknown action: " + action.type);
}

const Playlist = (
    {
        totalVideoPlayerHeight,
        accelerator,
        course,
        index,
        currentLesson,
        lessonComplete,
        setShowModal,
        expanded,
        setExpanded,
        playerTitleHeight,
        playerHeight,
        recordResultHeight,
        playerRef,
        videoLoaded,
        evaluationAnswer,
        firstTime,
        showVideoEnd,
        isShowCoachBanner,
        updateLessonCounter,
      updateDrillLessons,
      autoplayNextForCourse,
      setAutoplayNextForCourse,
      isInViewPortScrollableContainer,
      onSwitchAnchorMount,
      handleAutoplayToggle,
      prevNextHeight
    }: {
        totalVideoPlayerHeight: number,
        accelerator: Accelerator,
        course: Course,
        index: number,
        currentLesson: CurrentLesson,
        lessonComplete: {
            lessonID: number,
            courseID: number,
            wasComplete: boolean
        },
        setShowModal: (params: boolean) => void,
        expanded: number | boolean,
        setExpanded: React.Dispatch<React.SetStateAction<number | boolean>>,
        playerTitleHeight: number,
        playerHeight: number,
        recordResultHeight:number,
        playerRef: null | HTMLDivElement,
        videoLoaded: boolean,
        evaluationAnswer: string,
        firstTime: boolean,
        showVideoEnd: boolean,
        isShowCoachBanner:boolean;
        updateLessonCounter:()=>void;
        updateDrillLessons?:any,
        autoplayNextForCourse: boolean,
        setAutoplayNextForCourse: (value: boolean) => void,
        isInViewPortScrollableContainer: boolean,
        onSwitchAnchorMount: (el: HTMLDivElement | null, index: number) => void;
        handleAutoplayToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
        prevNextHeight: number,
    }
) => {
    const [lessonPlaylist, dispatch] = useReducer(reducer, course.lessons);
    const [recordResult, setRecordResult] = useState(false);
    const [animatedLessonId, setAnimatedLessonId] = useState<number | null>(
      null
   );
   const [recordLesson, setRecordLesson] = useState<Lesson>({
      content: "",
      lesson_type: "",
      link: {} as Link,
      url: "",
      drill_redirect_url:"",
      records: [],
      is_fav: false,
      video: {
         ID: 0,
         progress: 0,
         url: "",
         embed_url: "",
         duration: "",
         subheading: "",
         button_text: "",
         button_url: "",
         text_under_button: ""
      },
      ID: 0,
      complete: false,
      duration: "",
      name: "",
      is_pro_edition: false,
      drill: {
         game_rules: "",
         record_label: "",
         record_label_desc: "",
         scoring_system: "",
         subheading: "",
      },
      cta: {
         text: "",
         url: "",
      },
      linkIcon: ""
   });
   const [resultsDialogOpen, setResultsDialogOpen] = useState(false);
   const navigate = useNavigate();
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
   const [scrollOffset, setScrollOffset] = useState(0);
   const { accelerators, setAccelerators } = useAccelerator();
   const [accordingWidth, setAccordingWidth] = useState(0)
   const [accordingHeight, setAccordingHeight] = useState(0)
   const [isSharingThingOpened, setIsSharingThingOpened] = useState<Record<number, boolean>>({});
   const [lessonsThing, setLessonsThing] = useState<any>(lessonPlaylist);
   const [progress, setProgress] = useState(course.progress)

   const location = useLocation();
   const mobileTabletRange = useMediaQuery('(min-width:769px) and (max-width:1200px)');
   const [firstTimeComplete, setFirstTimeComplete] = useState(0);

   const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
   const [dismissClicked, setDismissClicked] = useState(true);
   const switchAnchorRef = useRef<HTMLElement | null>(null);

   const handleCloseTip = () => {
      setDismissClicked(true);
      setAnchorEl(null);
   };

   const open = Boolean(anchorEl);

  const [isVisible, setIsVisible] = useState(false);

  const wrapperRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const inView = entry.isIntersecting;
        setIsVisible(inView);
      },
      {
        root: document.querySelector('.Scrollable-Container'),
        threshold: 1,
      }
    );

    if (wrapperRef.current) {
      observer.observe(wrapperRef.current);
    }

    return () => {
      if (wrapperRef.current) observer.unobserve(wrapperRef.current);
    };
  }, []);

  useEffect(() => {
      if (!isVisible) {
         setAnchorEl(null);
      } else if(!dismissClicked) {
         setAnchorEl(switchAnchorRef.current);
      }
   }, [isVisible]);


   const didMountRef = useRef(false);
   useEffect(() => {
      if (!didMountRef.current) {
         didMountRef.current = true;
         return;
      }
      if(!autoplayNextForCourse && isVisible && wrapperRef.current) {
         setAnchorEl(switchAnchorRef.current);
         setDismissClicked(false);
      } else {
         setAnchorEl(null);
         setDismissClicked(true);
      }
   }, [autoplayNextForCourse]);

   useEffect(() => {
      if (
         lessonComplete.courseID === course.ID &&
         !lessonComplete.wasComplete
      ) {
         setFirstTimeComplete(lessonComplete.lessonID);
         axiosRequestData(
            "POST",
            "/wp-json/pg/v2/lesson/" + lessonComplete.lessonID + "/complete",
            { courseID: accelerator.ID }
         ).then((response) => {
            const foundlesson = lessonPlaylist.find(
               (index) => index.ID === lessonComplete.lessonID
            )?.drill;
            !foundlesson
               ? lessonCompleteEvent(
                    lessonComplete,
                    lessonPlaylist,
                    course,
                    accelerator
                 )
               : drillCompleteEvent(
                    lessonComplete,
                    lessonPlaylist,
                    course,
                    accelerator
                 );
            let lesson = course.lessons.find(
               (el) => el.ID === lessonComplete.lessonID
            );
            if (lesson && Object.keys(lesson.drill ?? {}).length === 0) {
               course.progress = Math.round(
                  ((lessonPlaylist.filter(
                     (el) =>
                        el.lesson_type === "video" &&
                        el.complete &&
                        Object.keys(el.drill ?? {}).length === 0
                  ).length +
                     1) /
                     lessonPlaylist.filter(
                        (el) => Object.keys(el.drill ?? {}).length === 0
                     ).length) *
                     100
               );
               setProgress(Math.round(
                  ((lessonPlaylist.filter(
                     (el) =>
                        el.lesson_type === "video" &&
                        el.complete &&
                        Object.keys(el.drill ?? {}).length === 0
                  ).length +
                     1) /
                     lessonPlaylist.filter(
                        (el) => Object.keys(el.drill ?? {}).length === 0
                     ).length) *
                     100
               ));
            }
            let updatedAccelerators = accelerators.map((el) => {
               let course = el.courses.find(
                  (course) => course.ID === lessonComplete.courseID
               );
               if (course) {
                  let courseIndex = el.courses.indexOf(course);
                  let lesson = course.lessons.find(
                     (lesson) => lesson.ID === lessonComplete.lessonID
                  );
                  if (lesson) {
                     let lessonIndex = course.lessons.indexOf(lesson);
                     lesson = { ...lesson, complete: true };
                     course.lessons.splice(lessonIndex, 1, lesson);
                     el.courses.splice(courseIndex, 1, course);
                  }
                  return el;
               } else return el;
            });
            setAccelerators(updatedAccelerators);
         });
      }
      // eslint-disable-next-line
   }, [lessonComplete]);

   useEffect(() => {
      // on lesson change stop prevous check animation
      setFirstTimeComplete(0);

   }, [currentLesson]);

    useEffect(() => {
        dispatch({type: 'set', lessons: course.lessons, lessonID: 0});
        setExpanded(currentLesson.courseID)
        // eslint-disable-next-line
    }, [course]);

   const isIOS = () => {
      const ua = navigator.userAgent;
      // legacy iOS (iPhone/iPad/iPod)
      if ( /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream ) {
         return true;
      }
      // iPadOS 13+ Safari detection
      if (/\bMacintosh\b/.test(ua) && navigator.maxTouchPoints > 1) {
         return true;
      }
      return false;
   };

   const playLesson = (lesson: Lesson) => {
      updateLessonCounter();

      setTimeout(() => {
      function getVimeoPlayerSize(): [number, number] {
         const width: number = window.innerWidth - 40;
         const height: number = width * 9 / 16;
         
         return [width, height];
      }

      const divEle = document.createElement("div");
      const divImg = document.createElement("img");
      const divParagraph = document.createElement("p");

      divImg.src = "https://www.performancegolf.com/wp-content/uploads/2023/11/Video-Icon.png"
      divImg.style.height = "100%";
      divImg.style.marginRight = "7px";
      const divTextContent = lesson.name + " (00:00)";
      
      divEle.appendChild(divImg);
      divParagraph.textContent = divTextContent;
      divParagraph.style.marginBottom = "0";
      divParagraph.style.fontSize = "14px";
      divParagraph.style.color = "#fff";

      divEle.appendChild(divParagraph);
      divEle.style.padding = "8px";
      divEle.style.marginLeft = "20px";
      divEle.style.marginRight = "20px";
      divEle.style.background = "#000";
      divEle.style.display = "flex";
      divEle.style.opacity = "0";

      document.body.appendChild(divEle);

      const [_, playerHeight] = getVimeoPlayerSize();
      let clonedNodeHeight = divEle.offsetHeight;

      const playingLessonId = lesson.ID;
      const playingLessonElement = document.querySelector(`#lesson-element-${playingLessonId}`);

      const currentAccordion = playingLessonElement?.closest('[id^="accordion-header-"]');

      const currentBanner = currentAccordion?.querySelector('[id^="accordion-header-"]');
      const currentBannerHeight = currentBanner?.clientHeight;

         if (accelerator.name === "Drills") {
            if (playingLessonElement && currentBannerHeight) {
               void divEle.offsetHeight;
               setTimeout(() => {
                  requestAnimationFrame(() => {
                     const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
                     const offset = playerHeight + clonedNodeHeight + currentBannerHeight + (window.innerWidth < 316 ? 58 : 43);
   
                     window.scrollTo({
                        top: elementTop - offset,
                        behavior: "smooth"
                     });
   
                     divEle.remove(); 
                  });
               }, 100);
               // const offset = playerHeight + clonedNodeHeight + currentBannerHeight + (window.innerWidth < 316 ? 58 : 43);

               // window.scrollTo({
               //    top: elementTop - offset,
               //    behavior: "smooth"
               // });
            }
            return;
         }
         if (playingLessonElement && currentBannerHeight) {
            const elementTop = playingLessonElement.getBoundingClientRect().top + window.scrollY;
            const offset = clonedNodeHeight + playerHeight + currentBannerHeight - (isIOS() ? 40 : 0);

            window.scrollTo({
               top: elementTop - offset,
               behavior: "smooth"
            });
         }

         divEle.remove();
      }, 1000);
      
      setShowModal(false);
      if (lesson.lesson_type === "video" && lesson.ID !== currentLesson.ID) {
         navigate(isDrillsPath(location.pathname) ? getLessonUrl(lesson.url,course.name) : removeDomainFromUrl(lesson.url));
      } else if (lesson.lesson_type === "link") {
         window.open(lesson.link.url);
      }
   };

   const updateAcceleratorsAfterToggleFav = (
      lesson: Lesson,
      isFav: boolean
   ) => {
      let updatedAccelerators = accelerators.map((el) => {
         let courseInAccelerator = el.courses.find(
            (acceleratorCourse) => acceleratorCourse.ID === course.ID
         );
         if (courseInAccelerator) {
            let courseIndex = el.courses.indexOf(courseInAccelerator);
            let courseLesson = courseInAccelerator.lessons.find(
               (courseLesson) => courseLesson.ID === lesson.ID
            );
            if (courseLesson) {
               let lessonIndex = courseInAccelerator.lessons.indexOf(lesson);
               courseLesson = { ...courseLesson, is_fav: isFav };
               courseInAccelerator.lessons.splice(lessonIndex, 1, courseLesson);
               el.courses.splice(courseIndex, 1, courseInAccelerator);
            }
            return el;
         } else return el;
      });
      setAccelerators(updatedAccelerators);
   };

   const handleSharingThing = (lessonID: number) => {
      setIsSharingThingOpened((prevState) => ({
         ...prevState,
         [lessonID]: !prevState[lessonID], 
      }));
   }

   const toggleCompletion = (lesson: Lesson) => {
      setLessonsThing((prevLessons: any) => {
         return prevLessons.map((l: any) => {
            if (l.ID === lesson.ID) { 
               return { ...l, complete: !l.complete };  
            }
            return l;
         });
      });

      lessonsThing.forEach((lessonThing: Lesson) => {
         if (lessonThing.ID === lesson.ID) {
            if (lesson.complete) {
               handleMarkAsIncomplete(lesson);
            } else {
               handleMarkAsComplete(lesson);
            }
         }
      })

   };
   const handleMarkAsIncomplete = (lesson: Lesson) => {
      lesson.complete = false;
      if (accelerator.name === "Drills" && lesson.drill)  {
         axiosRequestData("POST", "/wp-json/pg/v2/lesson/" + lesson.ID + "/remove_complete_drills", {
            courseID: accelerator.ID,
            course: course,
         }).then((response) => {            
            if (accelerator.name !== "Drills" && lesson.drill) {
               return;
            }
            setProgress(response.data.data.progress);
         });
         return;
      }
      axiosRequestData("POST", "/wp-json/pg/v2/lesson/" + lesson.ID + "/remove_complete",
            { courseID: accelerator.ID }).then((response) => {            
         if (accelerator.name !== "Drills" && lesson.drill) {
            return;
         }
         setProgress(response.data.data.progress);
      });
   }

   const handleMarkAsComplete = (lesson: Lesson) => {
      lesson.complete = true;
      if (accelerator.name === "Drills" && lesson.drill)  {
         console.log("v drills sme")
         axiosRequestData("POST", "/wp-json/pg/v2/lesson/" + lesson.ID + "/complete_drills", {
            courseID: accelerator.ID,
            course: course,
         }).then((response) => {            
            if (accelerator.name !== "Drills" && lesson.drill) {
               return;
            }
            setProgress(response.data.data.progress);
         });
         return;
      }
      axiosRequestData("POST", "/wp-json/pg/v2/lesson/" + lesson.ID + "/complete",
            { courseID: accelerator.ID }).then((response) => {            
         if (accelerator.name !== "Drills" && lesson.drill) {
            return;
         }
         setProgress(response.data.data.progress);
      });
   }

   const toggleFavorite = (lesson: Lesson) => {
      if (lesson.is_fav) {
        axiosRequestData(
          "DELETE",
          "/wp-json/pg/v2/lesson/" + lesson.ID + "/favorite",
            { courseID: accelerator.ID }
        ).then((response) => {
          updateAcceleratorsAfterToggleFav(lesson, false);
          addToNavigationFavoriteCount(-1, isMobile);
          if (isDrillsPath(location.pathname)) {
            dispatch({ type: 'toggle_favorite', lessonID: lesson.ID, lessons: [] });
          }
        });
      } else {
        axiosRequestData(
          "POST",
          "/wp-json/pg/v2/lesson/" + lesson.ID + "/favorite",
            { courseID: accelerator.ID }
        ).then((response) => {
          updateAcceleratorsAfterToggleFav(lesson, true);
          addToNavigationFavoriteCount(1, isMobile);
          setAnimatedLessonId(lesson.ID);
          setTimeout(() => setAnimatedLessonId(null), 1000);
          if (isDrillsPath(location.pathname)) {
            dispatch({ type: 'toggle_favorite', lessonID: lesson.ID, lessons: [] });
          }
        });
      }
   };

   const handleChange =
      (panel: number) =>
      (event: React.SyntheticEvent, newExpanded: boolean) => {
         // isMobile ? void (0) :
         setExpanded(newExpanded ? panel : false);
      };

   const openRecordResultDialog = (event: any, lesson: Lesson) => {
      event.stopPropagation();
      if (lesson.drill) {
         if (isMobile) {
            setScrollOffset(window.scrollY);
            document.body.style.touchAction = "none";
            document.body.style.position = "fixed";
            document.body.style.top = -scrollOffset + "px";
         }
         setRecordResult(true);
         setRecordLesson(lesson);
      }
   };

   const handleCloseDialog = () => {
      if (isMobile) {
         document.body.style.touchAction = "auto";
         document.body.style.position = "unset";
         window.scrollTo(0, scrollOffset);
      }
      setResultsDialogOpen(false);
   };

   //Ball striking adhoc solution for dynamic evaluation modal
   const filterLessons = (lesson: Lesson) => {
      if (
         evaluationAnswer === "" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         currentLesson.courseID !== course.ID
      )
         return false;
      else if (
         evaluationAnswer === "Push Slice" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         course.ID !== FIRST_COURSE_ID
      ) {
         return false;
      } else if (
         evaluationAnswer === "Pull Slice" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         course.ID !== SECOND_COURSE_ID
      ) {
         return false;
      } else if (
         evaluationAnswer === "Pull Hook" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         course.ID !== THIRD_COURSE_ID
      ) {
         return false;
      } else if (
         evaluationAnswer === "Straight Push" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         course.ID !== FOURTH_COURSE_ID
      ) {
         return false;
      } else if (
         evaluationAnswer === "Straight Pull" &&
         lesson.lesson_type === "video" &&
         Object.keys(lesson.drill ?? {}).length !== 0 &&
         accelerator.ID === BALL_STRIKING_ID &&
         course.ID !== FIFTH_COURSE_ID
      ) {
         return false;
      }

      return true;
   };

   const myRef = useRef<null | HTMLDivElement>(null);
   const accordionRef = useRef<HTMLDivElement>(null!);
   const accordingRef = useRef<null | HTMLDivElement>(null);
   const [bannerHeight, setBannerHeight] = useState(0)



   // useEffect(() => {

   //     if (isMobile && expanded === course.ID && currentLesson.courseID === course.ID && myRef.current) {
   //         myRef.current.scrollIntoView({
   //             behavior: "auto",
   //             block: "start"
   //         })

   //         // @ts-ignore
   //         setTimeout(() => playerRef.current.scrollIntoView({
   //             behavior: "auto",
   //             block: "start"
   //         }), 450)
   //     }
   //     console.log("scroll one")
   //     // eslint-disable-next-line
   // }, [expanded, course.ID]);

   useEffect(() => {
      if (!isMobile) {
         const scrollToAccordionHeader = () => {
            if (isMobile && expanded === course.ID && myRef.current) {
               const accordionHeader = document.getElementById(
                  `accordion-header-${course.ID}`
               );
               const lessonContainer = document.getElementById(
                  `lesson-container-${course.ID}`
               );
   
               if (accordionHeader && lessonContainer) {
                  // Scroll to the calculated position
                  myRef.current.scrollIntoView({
                     behavior: "auto",
                     block: "start",
                  });
               }
            }
         };
   
         scrollToAccordionHeader();
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [expanded, course]);

   function hasLessonWithNonEmptyDrill(lessons: Lesson[]) {
      return lessons.some(
         (lesson) => Object.keys(lesson.drill ?? {}).length !== 0
      );
   }

    useEffect(() => {
        setTimeout(() => {
         if (!isMobile) {
            const lessonElement = document.getElementById(`lesson-element-${currentLesson.ID}`);
            const scrollContainer = document.querySelector('.ScrollbarsCustom') || document.querySelector('.playListLessons');

            if (lessonElement && scrollContainer) {
                const hasScrolled = scrollContainer.getAttribute('data-scrolled') === 'true';

                let scrollToElement =  lessonElement.previousElementSibling || lessonElement;
                if (!hasScrolled) {
                    if (isMobile) {
                        let nextMobileElement = lessonElement.nextElementSibling || lessonElement;
                        nextMobileElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
                    } else if (mobileTabletRange) {
                        lessonElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
                    } else {
                        scrollToElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
                    }
                    scrollContainer.setAttribute('data-scrolled', 'true');
                }
            }
         }
        }, 1000);
    }, [currentLesson.ID]);

    return (
        <>
            <Box className="row" ref={myRef}  sx={{scrollMarginTop: `${playerTitleHeight + playerHeight + recordResultHeight}px`}}>
                <Accordion id={"accordion-header-" + course.ID.toString()}
                           expanded={true}>
                    <Box p={0} m={0}
                         sx={{
                             position: {xs: "sticky", md: "inherit"},
                             top: isMobile ? `${playerTitleHeight + playerHeight + recordResultHeight + prevNextHeight}px` : 0,
                             zIndex: 4,
                             backgroundColor: "#FCFAFA"
                         }}
                    >
                        <AccordionSummary
                                          className={expanded === course.ID ? styles.activeCourseHeader : ''}
                                          id={`accordion-header-${course.ID}`}>
                            <Typography
                              sx={{
                                 fontSize: 22,
                                 lineHeight: "22px",
                                 margin: 0,
                                 fontWeight: 500,
                                 textTransform: "uppercase",
                                 fontFamily: 'Repro',
                              }}
                                className={styles.lessonTitle}>{isDrillsPath(location.pathname)? `Drills - ${parse(course.name)}`: `Course ${index + 1}: ${parse(course.name)}`}</Typography>
                                {isMobile && (<br/>)}
                                 <Typography
                                    sx={{
                                       fontSize: 16,
                                       lineHeight: "16px",
                                       fontWeight: 400,
                                       fontFamily: 'Repro',
                                       textTransform: 'capitalize',
                                       margin: '10px 0px 0px',
                                       marginTop: { xs: "0", md: "10px" },
                                 }}> 
                                    ({course.lessons.filter(el => el.lesson_type === 'video').length}
                                    {course.lessons.filter(el => el.lesson_type === 'video').length > 1 ? ' videos' : ' video'})
                                 </Typography>
                            <Box className={styles.statusCourse}>
                                <Typography sx={{ fontSize: "14px", margin: "5px 0", fontFamily: "Repro" }}>{progress}% <span style={{textTransform: 'capitalize'}}>{window.pg?.l10n.complete}</span></Typography>                            
                                 <Box sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                 }}>
                                    <Tooltip title="Enable / disable autoplay">
                                       <Box
                                          sx={{
                                             width: 12,
                                             height: 12,
                                             backgroundColor: "#000",
                                             borderRadius: "50%",
                                             color: "#F4F2F0",
                                             display: "flex",
                                             alignItems: "center",
                                             justifyContent: "center",
                                             fontSize: 11,
                                             fontWeight: 700,
                                             lineHeight: 1,
                                             cursor: "default",
                                             userSelect: "none"
                                          }}
                                       >
                                          i
                                       </Box>
                                    </Tooltip>
                                    <Typography
                                       sx={{
                                             color: "black",
                                             fontFamily: "Repro",
                                             fontSize: "14px",
                                             fontWeight: 400,
                                             lineHeight: "14px",
                                             margin: 0,
                                       }}
                                    >
                                       {window.pg?.l10n.auto_paly}
                                    </Typography>
                                    <Box ref={(el: HTMLDivElement | null) => onSwitchAnchorMount(el, index)} data-index={index}>
                                       <Box ref={switchAnchorRef} sx={{display: "flex", height: '15px' }}>
                                       <Switch
                                          checked={autoplayNextForCourse}
                                          onChange={handleAutoplayToggle}
                                          sx={{
                                             width: '24px',
                                             height: '16px',
                                             padding: 0,
         
                                             '& .MuiSwitch-switchBase': {
                                                padding: '2px',
                                                '&.Mui-checked': {
                                                   color: '#FFFFFF',
                                                   transform: 'translateX(8px)',
                                                   '& + .MuiSwitch-track': {
                                                      backgroundColor: '#FD3300',
                                                      opacity: 1,
                                                   },
                                                },
                                             },
         
                                             '& .MuiSwitch-thumb': {
                                                backgroundColor: '#FFFFFF',
                                                width: '12px',
                                                height: '12px',
                                             },
         
                                             '& .MuiSwitch-track': {
                                                backgroundColor: '#B7B7BF',
                                                opacity: 1,
                                                borderRadius: '12px',
                                             },
                                          }}
                                       />
                                       <div ref={wrapperRef}>
                                          {isInViewPortScrollableContainer && <AutoplayPopover
                                             open={open}
                                             anchorEl={anchorEl}
                                             handleCloseTip={handleCloseTip}
                                          ></AutoplayPopover>}
                                       </div>
                                       </Box>
                                    </Box>
                                 </Box>
                            </Box>
                            
                            <BorderLinearProgressHeight6
                                variant="determinate" value={progress}/>
                        </AccordionSummary>
                    </Box>


               <AccordionDetails id={`lesson-container-${course.ID}`}>
                     {/* Current removed DIDYOUKNOWBANNEr */}
                     {/* {isShowCoachBanner  && expanded === course.ID && <DidYouKnowBannerCoach playerTitleHeight={playerTitleHeight} playerHeight={playerHeight}  accordinRef={accordionRef} accelerator={accelerator} lesson={currentLesson}/>}
                     {expanded === course.ID && <DidYouKnowMessageBanner accordingWidth={accordingWidth} accordingHeight={accordingHeight} playerHeight={playerHeight}  setBannerHeight={setBannerHeight} lessonComplete={lessonComplete} courseId={course.ID} expanded={expanded} accelerator={accelerator} />} */}
                     {lessonPlaylist.length > 3 && !isDrillsPath(location.pathname) &&
                     hasLessonWithNonEmptyDrill(lessonPlaylist) &&
                     currentLesson.ID !=
                        lessonPlaylist[lessonPlaylist.length - 1].ID && (
                        <div
                           className={styles.drillBannerOuterRebrand}
                           onClick={() => {
                              playLesson(
                                 lessonPlaylist[lessonPlaylist.length - 1]
                              );
                              const drillElement = document.getElementById(
                                 `lesson-element-${
                                    lessonPlaylist[lessonPlaylist.length - 1].ID
                                 }`
                              );
                              const lessonContainer = document.getElementById(
                                 `lesson-container-${course.ID}`
                              );
                              if (drillElement && lessonContainer) {
                                 if (!isMobile){
                                    drillElement.scrollIntoView({
                                       block: "center",
                                       behavior: "smooth",
                                    });
                                 }
                                 else {
                                    drillElement.scrollIntoView({
                                       block: "end",
                                       behavior: "smooth",
                                    });
                                 }
                              }
                           }}
                        >
                           <div
                              style={{
                                 marginLeft: "16px",
                                 paddingTop: "0",
                              }}
                           >
                              {/* <img
                                 src="https://members.performancegolf.com/wp-content/uploads/2025/03/Club.svg"
                                 alt="mySvg"
                              /> */}
                           </div>
                           <div
                              style={{
                                 marginLeft: "12px",
                                 paddingTop: "0",
                                 marginRight: "20px",
                                 width: "100%",
                                 display: "flex",
                                 justifyContent: "space-between",
                                 alignItems: "center",
                              }}
                           >
                              <div style={{fontSize: "16px"}}>
                              <p style={{ marginBottom: 0 }}>
                                 Try This Training Drill!
                              </p>
                              {/* <div
                                 style={{
                                    // display: "flex",
                                    // justifyContent: "space-between",
                                    // alignItems: "center",
                                    // width: "100%",
                                    //gap: "40px",
                                 }}
                              > */}
                                 <div style={{ fontWeight: "bold" }}>
                                    {
                                       lessonPlaylist[lessonPlaylist.length - 1]
                                          .name
                                    }
                                 </div>
                                 </div>
                                 <div className={styles.clickHereDrill}>
                                    Click here
                                 </div>
                              {/* </div> */}
                           </div>
                        </div>
                     )}
                  {lessonPlaylist
                     .filter(filterLessons)
                     .map((lesson, lessonIndex) => {
                        return (
                           <>
                           <Grid
                              container
                              key={lessonIndex}
                              id={`lesson-element-${lesson.ID}`}
                              borderTop={"1px solid hsla(0,0%,86%,.45)"}
                              // MAR-684-DZELAL
                              style={{background:`${currentLesson.ID !== lesson.ID && isDrillsPath(location.pathname) ? '#FFF':'#FCFAFA'}`}}
                              className={
                                 currentLesson.video.embed_url ===
                                 lesson.video.embed_url
                                    ? styles.active
                                    : Object.keys(lesson.drill ?? {}).length !==
                                         0 || lesson.lesson_type === "link"
                                    ? styles.drill
                                    : ""
                              }
                           >
                              <Grid
                                 item
                                 xs={isMobile ? 9 : 10}
                                 className={styles.label}
                                 onClick={() => playLesson(lesson)}
                              >
                                 <Grid container height={"100%"}>
                                    {Object.keys(lesson.drill ?? {}).length ===
                                       0 &&
                                       lesson.lesson_type === "link" && (
                                          <Grid item xs={11} mx={2} padding={0}>
                                             {lesson.complete && firstTimeComplete !== lesson.ID && (
                                                <Box
                                                   component={"img"}
                                                   sx={{
                                                      width: "26px",
                                                      height: "26px",
                                                      margin:
                                                         "auto 10px auto 0",
                                                   }}
                                                   src="https://www.performancegolf.com/wp-content/uploads/2023/11/Point-Value.png"
                                                   alt=""
                                                />
                                             )}
                                             {lesson.complete && firstTimeComplete === lesson.ID && !lessonComplete.wasComplete &&
                                             <Box
                                                sx={{
                                                   position: "relative",
                                                   width: { xs: "24px", md: "35px" },
                                                   height: { xs: "24px", md: "35px" },
                                                   margin: "auto 7px auto -4px",
                                                   aspectRatio: "1 / 1",
                                                }}
                                                >
                                                   <CheckAnimation/>
                                                </Box>
                                             }  
                                             <Box
                                                display={"flex"}
                                                py={3}
                                                margin={"auto"}
                                             >
                                                <Typography marginRight={1}>
                                                   {lessonIndex + 1}.
                                                </Typography>
                                                <Box>
                                                   <Typography
                                                      fontSize={16}
                                                      fontWeight={700}
                                                      margin={0}
                                                   >
                                                      {parse(lesson.name)}
                                                   </Typography>
                                                   <Button
                                                      variant="contained"
                                                      sx={{
                                                         backgroundColor:
                                                            "#FD3300",
                                                         marginTop: "15px",
                                                         "&:hover": {
                                                            backgroundColor:
                                                               "#fd0000",
                                                         },
                                                      }}
                                                      onClick={(event) =>
                                                         window.open(
                                                            lesson.link.url
                                                         )
                                                      }
                                                   >
                                                      <Typography
                                                         fontSize={14}
                                                         fontWeight={700}
                                                      >
                                                         {lesson.link.label}
                                                      </Typography>
                                                   </Button>
                                                </Box>
                                             </Box>
                                          </Grid>
                                       )}

                                    {Object.keys(lesson.drill ?? {}).length ===
                                       0 &&
                                       lesson.lesson_type === "video" && (
                                          <Grid
                                             item
                                             xs={11}
                                             padding={0}
                                             display={"flex"}
                                             margin={"auto"}
                                          >
                                             {lesson.complete && firstTimeComplete !== lesson.ID && (
                                                <Box
                                                   component={"img"}
                                                   sx={{
                                                      width: { xs: "18px", md: "26px" },
                                                      height: { xs: "18px", md: "26px" },
                                                      margin:
                                                         "auto 10px auto 0",
                                                   }}
                                                   src="https://www.performancegolf.com/wp-content/uploads/2023/11/Point-Value.png"
                                                   alt=""
                                                />
                                             )}
                                             {lesson.complete && firstTimeComplete === lesson.ID && !lessonComplete.wasComplete&&
                                                <Box
                                                   sx={{
                                                      position: "relative",
                                                      width: { xs: "24px", md: "35px" },
                                                      height: { xs: "24px", md: "35px" },
                                                      margin: "auto 7px auto -4px",
                                                      aspectRatio: "1 / 1",
                                                   }}
                                                >
                                                   <CheckAnimation/>
                                                </Box>
                                             }
                                             <Typography
                                                sx={{
                                                   display: "flex",
                                                   flexDirection: "row",
                                                   alignItems: {xs: "center", md: "flex-start"}, // Align items vertically in the center
                                                   fontSize: "16px",
                                                }}
                                                // fontSize={16}
                                                margin={0}
                                             >
                                                {(!lesson.complete || !isMobile) && (
                                                   <Typography
                                                      component="span"
                                                      sx={{
                                                         fontSize: { xs: "14px", md: "16px" },
                                                         marginRight: { xs: "12px", md: "8px" }
                                                      }}
                                                   >
                                                      {lessonIndex + 1}.
                                                   </Typography>
                                                )}
                                                {/* <span
                                                   style={{
                                                      marginRight: "8px",
                                                      fontSize: isMobile ? "14px" : "16px"
                                                   }}
                                                >
                                                   {lessonIndex + 1}.
                                                </span> */}
                                                <span
                                                   style={{
                                                      flexGrow: 1,
                                                      marginRight: "8px",
                                                      fontWeight: '400',
                                                      fontSize: "16px",
                                                   }}
                                                >
                                                   <Typography
                                                      component="span"
                                                      sx={{
                                                         fontWeight: '400',
                                                         fontSize: "16px",
                                                      }}
                                                   >
                                                      {parse(lesson.name)} (
                                                   </Typography>
                                                   {getTimeFromSeconds(
                                                      Number(
                                                         lesson.video.duration
                                                      )
                                                   )}
                                                   )
                                                </span>
                                                {/* <span>({getTimeFromSeconds(lesson.video.duration)})</span> */}
                                             </Typography>
                                          </Grid>
                                       )}

                                    {Object.keys(lesson.drill ?? {}).length !==
                                       0 && (
                                       <Grid
                                          item
                                          xs={lesson.complete ? 10 : 11}
                                          // mx={2}
                                          sx={{
                                             marginLeft: { xs: "10px", md: "16px" },
                                             marginRight: { xs: "10px", md: "16px" },
                                          }}
                                          padding={0}
                                       >
                                          <Box
                                             display={"flex"}
                                             py={3}
                                             margin={"auto"}
                                          >
                                             {lesson.complete && firstTimeComplete !== lesson.ID && (
                                                <Box
                                                   component={"img"}
                                                   sx={{
                                                      width: { xs: "18px", md: "26px" },
                                                      height: { xs: "18px", md: "26px" },
                                                      margin: "0 10px auto 0",
                                                   }}
                                                   src="https://www.performancegolf.com/wp-content/uploads/2023/11/Point-Value.png"
                                                   alt=""
                                                />
                                             )}
                                             {firstTimeComplete === lesson.ID &&
                                                <Box
                                                   sx={{
                                                      position: "relative",
                                                      width: { xs: "24px", md: "35px" },
                                                      height: { xs: "24px", md: "35px" },
                                                      margin: "0 7px auto -4px",
                                                      aspectRatio: "1 / 1",
                                                   }}
                                                >
                                                   <CheckAnimation/>
                                                </Box>
                                             }  

                                             {(!lesson.complete || !isMobile) && (
                                                <Typography marginRight={1}>
                                                   {lessonIndex + 1}.
                                                </Typography>
                                             )}
                                             <Box>
                                                <Typography
                                                   sx={{
                                                      fontSize: "16px"
                                                   }} 
                                                   // fontSize={16}
                                                   margin={0}
                                                >
                                                   Training drill:
                                                </Typography>
                                                <Typography
                                                   // fontSize={16}
                                                   sx={{
                                                      fontSize: "16px"
                                                   }} 
                                                   fontWeight={700}
                                                   margin={0}
                                                >
                                                   {parse(lesson.name)}
                                                </Typography>
                                                <Button
                                                   variant="contained"
                                                   sx={{
                                                      backgroundColor:
                                                         "#FD3300",
                                                      marginTop: "15px",
                                                      "&:hover": {
                                                         backgroundColor:
                                                            "#fd0000",
                                                      },
                                                   }}
                                                   onClick={(event) =>
                                                      openRecordResultDialog(
                                                         event,
                                                         lesson
                                                      )
                                                   }
                                                >
                                                   <Typography
                                                      fontSize={14}
                                                      fontWeight={700}
                                                   >
                                                      Record results
                                                   </Typography>
                                                </Button>
                                             </Box>
                                          </Box>
                                       </Grid>
                                    )}
                                 </Grid>
                              </Grid>
                              {lesson.lesson_type !== "link" && (
                                 <Grid item sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-around"
                                 }}
                                    xs={isMobile ? 3 : 2}
                                 >
                                    <Grid
                                       item
                                       id={`lesson-${lesson.ID}`}
                                       className={styles.favStar}
                                       sx={{ 
                                          py: 3,
                                          margin: {xs: "0", sm: "auto"}
                                       }}
                                       // margin={"auto"}
                                       textAlign={"center"}
                                       onClick={() => {
                                          toggleFavorite(lesson);
                                          favoriteVideoEvent(
                                             lesson,
                                             course,
                                             !lesson.is_fav,
                                             accelerator
                                          );
                                       }}
                                    >
                                       {lesson.is_fav ? (
                                          <StarRateRoundedIcon
                                             className={`${styles.favStar} ${
                                                styles.starFavorited
                                             } ${
                                                animatedLessonId === lesson.ID
                                                   ? styles.favPop
                                                   : ""
                                             }`}
                                             color={"primary"}
                                          />
                                       ) : (
                                          <StarBorderRoundedIcon
                                             className={`${styles.favStar}`}
                                          />
                                       )}
                                       {/* <StarBorderRoundedIcon
                                          className={`${styles.favStar} ${
                                             lesson.is_fav
                                                ? styles.starFavorited
                                                : ""
                                          } ${animateStar ? styles.favPop : ""}`}
                                       /> */}
                                 </Grid>
                                    {isMobile && (
                                          <Box
                                             component={"img"}
                                             sx={{
                                                width: { xs: "18px", md: "26px" },
                                                height: { xs: "18px", md: "26px" },
                                                margin: "auto 0 auto 0px"
                                             }}
                                             src="https://members.performancegolf.com/wp-content/uploads/2025/02/icon.svg"
                                             onClick={() => {
                                                handleSharingThing(lesson.ID);
                                             }}
                                             alt=""/>
                                    )}
                                 </Grid>
                              )}
                           </Grid>
                           {isMobile && isSharingThingOpened[lesson.ID] && <Box sx={{
                              paddingLeft: "16px",
                              paddingTop: "8px",
                              paddingBottom: "14px",
                           }}>
                              <Box>
                                 <Box onClick={() => {
                                    toggleCompletion(lesson);
                                 }} sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginBottom: "16px"
                                 }}>
                                    <Box
                                       component="img"
                                       sx={{marginRight: "16px"}}
                                       src={
                                          // lessonsThing.find((l: any) => l.ID === lesson.ID)?.complete || lesson.complete
                                          lesson.complete
                                          ? "https://members.performancegolf.com/wp-content/uploads/2025/02/Frame-143727386.svg"
                                          : "https://members.performancegolf.com/wp-content/uploads/2025/02/Icon.svg"
                                    }/>

                                    <Typography sx={{ fontSize: "14px" }}>
                                       {/* {lessonsThing.find((l: any) => l.ID === lesson.ID)?.complete || lesson.complete ? "Mark as Incomplete" : "Mark as Complete"} */}
                                       {lesson.complete ? "Mark as Incomplete" : "Mark as Complete"}
                                    </Typography> 

                                 </Box>
                              </Box>

                              <Box sx={{
                                 display: "flex",
                                 alignItems: "center",
                                 marginLeft: "2px"
                              }}
                                 onClick={(e: any) => {
                                    toggleFavorite(lesson)
                                    favoriteVideoEvent(lesson, course, !lesson.is_fav, accelerator)
                                 }}
                              >
                                 {lesson.is_fav &&
                                    <StarRateRoundedIcon color={"primary"}></StarRateRoundedIcon>}
                                 {!lesson.is_fav && <StarBorderRoundedIcon></StarBorderRoundedIcon>}

                                 {lesson.is_fav &&
                                    <Typography sx={{ fontSize: "14px", marginLeft: "18px"}}>Remove from Favorites</Typography>}
                                 {!lesson.is_fav && <Typography sx={{ fontSize: "14px", marginLeft: "18px"}}>Add to Favorites</Typography>}
                                 
                              </Box>
                           </Box>}
                           </>
                        );
                     })}
               </AccordionDetails>
            </Accordion>
         </Box>
         <ResultsDialog
            open={resultsDialogOpen}
            onClose={handleCloseDialog}
            onButton1Click={() => {
               document.body.style.touchAction = "auto";
               document.body.style.position = "unset";
               navigate("/scratch-club/record", {
                  state: { id: recordLesson },
               });
            }}
            onButton2Click={handleCloseDialog}
         />

         <RecordResultsDialog
            show={recordResult}
            setShow={(value) => setRecordResult(value)}
            lesson={recordLesson}
            callback={(data) => {
               setResultsDialogOpen(true)
               if(updateDrillLessons){
                  updateDrillLessons(recordLesson.ID,data)
               }
            }}
         />
      </>
   );
};

export default Playlist;
